import { type CSSProperties, useRef, useState } from "react";

import { useResizeObserver } from "../../hooks/use-resize-observer";
import { clsx } from "../../utils/clsx";
import { Presence, type PresenceProps } from "../presence/presence";

export interface CollapsibleProps extends Omit<PresenceProps, "present"> {
  children?: React.ReactNode;
  hidden?: boolean;
}

export const Collapsible = ({ children, className, hidden, ...rest }: CollapsibleProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | "auto">("auto");

  useResizeObserver(ref.current, () => {
    const observedHeight = ref.current?.getBoundingClientRect()?.height;
    if (observedHeight) setHeight(observedHeight);
  });

  return (
    <Presence
      present={!hidden}
      className={clsx(
        "overflow-hidden data-[state=hidden]:animate-collapsible-up data-[state=visible]:animate-collapsible-down",
        className,
      )}
      style={
        {
          "--content-height": typeof height === "number" && !Number.isNaN(height) ? `${height}px` : height.toString(),
        } as CSSProperties
      }
      {...rest}
    >
      <div ref={ref}>{children}</div>
    </Presence>
  );
};
